module.exports = __webpack_public_path__ + "ui-static/img/logo-large_dark.b206c135.svg";